import {
    URLAPI,
    TYPE_CUSTODY_PATH,
    TYPE_CUSTODY_CREATE_PATH,
    TYPE_CUSTODY_UPDATE_PATH,
    TYPE_CUSTODY_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_type_custody: {
        data: [],

        status: 0,
        message: {},
    },

    _create_type_custody: {
        data: {},
        status: 0,
        message: {},
    },
    _update_type_custody: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_type_custody: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_TYPE_CUSTODY = "GET_ALL_TYPE_CUSTODY";
export const CREATE_TYPE_CUSTODY = "CREATE_TYPE_CUSTODY";
export const UPDATE_TYPE_CUSTODY = "UPDATE_TYPE_CUSTODY";
export const DELETE_TYPE_CUSTODY = "DELETE_TYPE_CUSTODY";

export const type_custody_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_TYPE_CUSTODY:
            return {
                ...state,
                _get_all_type_custody: action.payload,
            };
        case CREATE_TYPE_CUSTODY:
            return {
                ...state,
                _create_type_custody: action.payload,
            };
        case UPDATE_TYPE_CUSTODY:
            return {
                ...state,
                _update_type_custody: action.payload,
            };
        case DELETE_TYPE_CUSTODY:
            return {
                ...state,
                _delete_type_custody: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllTypeCustody = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${TYPE_CUSTODY_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_TYPE_CUSTODY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_TYPE_CUSTODY,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_TYPE_CUSTODY,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

//create type_custody
export const createTypeCustody = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${TYPE_CUSTODY_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_TYPE_CUSTODY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_TYPE_CUSTODY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_TYPE_CUSTODY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateTypeCustody = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${TYPE_CUSTODY_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_TYPE_CUSTODY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_TYPE_CUSTODY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_TYPE_CUSTODY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteTypeCustody = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${TYPE_CUSTODY_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_TYPE_CUSTODY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_TYPE_CUSTODY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_TYPE_CUSTODY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_type_custody = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
